import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const ChatBubble1 = ({ msg, user }) => {
  console.log({ msg, user });
  return (
    <Box
      display="flex"
      justifyContent={
        user.name === msg?.author?.name ? "flex-start" : "flex-end"
      }
      alignContent="center">
      <Stack
        sx={{
          maxWidth: "80%",
        }}>
        <Typography align="left" variant="caption" color="textSecondary">
          {msg?.author?.name}
        </Typography>
        <Box
          sx={{
            display: "inline-block",
            margin: "0.5rem 0",
            padding: "0.5rem",
            borderRadius: "0.5rem",
            borderWidth: "1px ",
            borderStyle: "solid",
            borderColor:
              user.name === msg?.author?.name
                ? "primary.main"
                : "secondary.main",
          }}>
          <Typography
            align="center"
            variant="body2"
            color="textSecondary"
            component="p">
            {msg?.message}
          </Typography>
        </Box>
        <Typography align="right" variant="caption" color="textSecondary">
          {msg?.time}
        </Typography>
      </Stack>
    </Box>
  );
};

export default ChatBubble1;
